import * as core from '../../../../../../../core'
import * as spaceSurveyStatus from '../space-survey-status'

export const RESOURCE = {
  payload: {
    description: 'Not Started',
    enumId: core.dms.models.Enum.Id.from({
      partialId: spaceSurveyStatus.RESOURCE.payload.partialId,
    }),
    id: 'NOT_STARTED',
    name: 'Not Started',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
